import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { gql } from 'apollo-boost';
import { Mutation, Query } from 'react-apollo';
import { Formik } from 'formik';
import { locationValidationSchema } from '../../validation/location';
import LocationForm from '~/components/locationForm/locationForm';
import Spinner from '~/components/spinner/spinner';
import ErrorBoundaryContent from '~/components/errorBoundary/content';

export const geLocationQuery = gql`
  query location($id: Int!) {
    location(id: $id) {
      id
      name
      notes
    }
  }
`;

export const updateLocationsMutation = gql`
  mutation updateLocation($id: Int!, $name: String!, $notes: String) {
    updateLocation(id: $id, name: $name, notes: $notes) {
      id
      name
      breweryId
      notes
    }
  }
`;

const LocationEdit = ({ onCompleted, id, history }) => (
  <Query query={geLocationQuery} variables={{ id }} onCompleted={onCompleted} fetchPolicy={'cache-and-network'}>
    {props => {
      const { loading, error, data } = props;
      if (loading) {
        return <Spinner className="absolute absolute-center stroke-brand-red" />;
      }

      if (error) {
        return <ErrorBoundaryContent error={error} />;
      }

      const { location } = data;
      return (
        <div className="content">
          <Mutation mutation={updateLocationsMutation}>
            {(updateLocation, { error }) => (
              <Formik
                initialValues={location}
                validateOnChange={false}
                validateOnBlur={false}
                validationSchema={locationValidationSchema}
                onSubmit={async (values, { setErrors, setSubmitting }) => {
                  try {
                    await updateLocation({
                      variables: {
                        id,
                        ...values
                      }
                    });
                    history.push(`/settings/locations/${id}?updated=true`);
                  } catch (err) {
                    setErrors({
                      unknown: 'An unknown error occured'
                    });
                    setSubmitting(false);
                  }
                }}
                render={LocationForm}
              />
            )}
          </Mutation>
        </div>
      );
    }}
  </Query>
);

function mapStateToProps(state) {
  return {
    brewery: state.brewery
  };
}

export default connect(mapStateToProps)(withRouter(LocationEdit));



// WEBPACK FOOTER //
// ./src/containers/locationEdit/locationEdit.jsx